import { createBrowserRouter, RouterProvider } from "react-router-dom";
import  { AdminLayout, StudentLayout } from "../layouts/Layout";
import Login from "../auth/Login";
import TrainerLayout from "../layouts/Layout";
import ManageTrainers from "../admin/trainers/ManageTrainers";
import ManageStudents from "../admin/students/ManageStudents";
import ManageBatches from "../trainers/batches/ManageBatches";
import ManagePeople from "../trainers/peoples/ManagePeople";
import ManageSchedule from "../trainers/schedules/ManageSchedule";
import ManageTask from "../trainers/tasks/ManageTask";
import ManageMarks from "../trainers/marks/ManageMarks";
import PerformanceGraph from "../graphs/PerformanceGraph";
import ViewBatches from "../students/batches/ViewBatches";
import ViewSchedule from "../students/schedules/ViewSchedule";
import ViewTasks from "../students/tasks/ViewTasks";
import ViewTrainers from "../students/trainers/ViewTrainers";
import TrainerDashboard from "../trainers/TrainerDashboard";
import StudentDashboard from "../students/StudentDashboard";
import AdminBatches from "../admin/batches/AdminBatches";
import ManageAssignTrainer from "../trainers/peoples/ManageAssignTrainer";
import ManageMaterial from "../trainers/materials/ManageMaterial";
import ViewSubmissions from "../trainers/submissions/ViewSubmissions";
import AdminDashboard from "../pages/AdminDashboard";
import ViewMaterial from "../students/materials/ViewMaterial";
import BatchDetails from "../commonpage/BatchDetails";
import ViewTaskDetails from "../students/tasks/ViewTaskDetails";
import TaskDetails from "../trainers/tasks/TaskDetails";
export default function RoutingConfig(){
    const router=createBrowserRouter([
        {
            path:"/student",
            element:<StudentLayout/>,
            children:[
                {path:"/student", element:<StudentDashboard title="Dashboard"/>},
                {path:"batches", element:<ViewBatches title="Batches"/>},
                {path:"schedules/:batchId", element:<ViewSchedule title="Schedule"/>},
                {path:"material/:batchId", element:<ViewMaterial title="Material"/>},
                {path:"tasks/:batchId", element:<ViewTasks title="Tasks"/>},
                {path:"trainers/:batchId", element:<ViewTrainers title="Trainers"/>},
                {path:"graph/:batchId/:studentId", element:<PerformanceGraph title="Performance"/>},
                {path:"viewTaskDetails/:taskId", element:<ViewTaskDetails title="Upload Task"/>},

            ]
        },
        {
            path:"/admin",
            element:<AdminLayout/>,
            children:[
                {path:"/admin", element:<AdminDashboard title="Dashboard"/>},
                {path:"trainers", element:<ManageTrainers title="Trainers"/>},
                {path:"students", element:<ManageStudents title="Students"/>},
                {path:"batches", element:<AdminBatches title="Batch"/>},
                {path:"batches/trainer/:trainerId", element:<AdminBatches title="Batch"/>},
                {path:"batches/student/:studentId", element:<AdminBatches title="Batch"/>},
                {path:"viewBatches/:batchId", element:<BatchDetails title="Batch"/>},
                {path:"marks/:batchId/:testId", element:<ManageMarks title="Marks"/>},
                {path:"graph/:batchId/:studentId", element:<PerformanceGraph title="Performance"/>},
            ]
        },
        {
            path:"/trainer",
            element:<TrainerLayout/>,
            children:[
                {path:"/trainer", element:<TrainerDashboard title="Dashboard"/>},
                {path:"students", element:<ManageStudents title="Students"/>},
                {path:"batches", element:<ManageBatches title="Batch"/>},
                {path:"material/:batchId", element:<ManageMaterial title="Material"/>},
                {path:"peoples/:batchId", element:<ManagePeople title="Students"/>},
                {path:"trainers/:batchId", element:<ManageAssignTrainer title="Trainers"/>},
                {path:"schedules/:batchId", element:<ManageSchedule title="Schedule"/>},
                {path:"tasks/:batchId", element:<ManageTask title="Tasks"/>},
                {path:"marks/:batchId/:testId", element:<ManageMarks title="Marks"/>},
                {path:"graph/:batchId/:studentId", element:<PerformanceGraph title="Performance"/>},
                {path:"submission/:batchId/:taskId", element:<ViewSubmissions title="Submissions"/>},
                {path:"viewBatches/:batchId", element:<BatchDetails title="Batch"/>},
                {path:"taskdetails/:taskId/:studentId", element:<TaskDetails title="Task Details"/>},
            ]
        },
        {
            path:"/",
            element:<Login/>
        }
    ])
    return <RouterProvider router={router}/>
}